import React, { useEffect } from 'react';
import UnexpectedErrorImg from '../../images/unexpectedError.png';

import style from './index.module.scss';

const CHUNK_RELOAD_KEY = 'chunkLoadReloaded';

const isChunkLoadError = (error) =>
    error?.name === 'ChunkLoadError' || /Loading( CSS)? chunk \d+ failed/.test(error?.message || '');

const UnexpectedError = ({ error }) => {
    useEffect(() => {
        // A new deployment can leave the browser holding an old index.html that
        // still points at JS chunk files which no longer exist on the server,
        // so the dynamic import 404s instead of throwing a real app bug.
        // Reloading once fetches the current index.html/chunks and self-heals.
        if (isChunkLoadError(error) && !sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
            sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
            window.location.reload();
        }
    }, [error]);

    return (
        <div className={style.unexpectedErrorBackgroundCard}>
            <div className={style.verticalAlignCenter}>
                <div className={style.fullWidth}>
                    <div className={style.horizontalAlignCenter}>
                        <img alt='' src={UnexpectedErrorImg} className={style.errorImgStyle} />
                    </div>
                    <div className={style.horizontalAlignCenter}>
                        <div className={style.errorBorder}></div>
                    </div>
                    <div className={`${style.unexpectedErrormessageStyle} ${style.marginTop30}`}>Oops! Something seems to have gone wrong...</div>
                    <div className={`${style.unexpectedErrordescriptionStyle} ${style.marginTop20}`}>
                        We apologise for the inconvenience. This issue has automatically been logged and our team is looking into it. Please bear with us as we resolve this issue expeditiously.
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UnexpectedError;